import { LabelsMap } from 'new/form/common/types';

import { financingNeedSectionLabelsMap } from './sections/financingNeedSection/labels';
import { purposeSectionLabelsMap } from './sections/purposeSection/labels';

export const hausbankFinancingNeedLabelsMap: LabelsMap = {
  ...purposeSectionLabelsMap,
  ...financingNeedSectionLabelsMap,
};
